var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.post && _vm.post.details ? _c('div', {
    staticClass: "post-grid-card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "asset-container"
  }, [_vm.post.details.featuredImage ? _c('img', {
    attrs: {
      "src": _vm.post.details.featuredImage,
      "alt": "post featured image"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/defaultPostImage.png"),
      "alt": "Default Post Image"
    }
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('post-info', {
    attrs: {
      "post": _vm.post
    }
  }), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "title heading-3-bold"
  }, [_vm._v(_vm._s(_vm.post.details.title))]), _c('div', {
    staticClass: "short-description paragraph-1"
  }, [_vm._v(_vm._s(_vm.post.details.description))])])], 1), _c('div', {
    staticClass: "button-container"
  }, [_c('seu-button', {
    attrs: {
      "button-link": _vm.postLink.link,
      "target": _vm.postLink.target,
      "route": _vm.postLink.route,
      "label": _vm.$t('common.read_more')
    }
  }), _c('div', [_c('blog-social-links', {
    attrs: {
      "post": _vm.post
    }
  })], 1)], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }